import { ref } from 'vue';

export const useLoading = (initializedState = false) => {
  const isLoading = ref(initializedState);

  const startLoading = () => {
    isLoading.value = true;
  };

  const stopLoading = () => {
    isLoading.value = false;
  };

  const withLoading = (
    handler: (...params: any[]) => Promise<any>,
  ) => async (...params: any[]) => {
    if (isLoading.value) {
      return;
    }

    startLoading();

    await handler(...params).finally(() => stopLoading());
  };

  return {
    isLoading,
    startLoading,
    stopLoading,
    withLoading,
  };
};
